import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useActiveBadges } from "@/hooks/useBadges";

const NONE = "__none";

interface Props {
  value: string | null;
  onChange: (badgeId: string | null) => void;
  disabled?: boolean;
  disabledReason?: string;
}

/** Optional completion badge picker for curriculum and course forms. Lists active badges only. */
export function CompletionBadgeSelect({ value, onChange, disabled, disabledReason }: Props) {
  const { data: badges } = useActiveBadges();
  const current = value && badges.some((b) => b.id === value) ? value : value ? value : NONE;

  return (
    <div className="space-y-2">
      <Label>Completion badge (optional)</Label>
      <Select value={current} onValueChange={(v) => onChange(v === NONE ? null : v)} disabled={disabled}>
        <SelectTrigger>
          <SelectValue placeholder="None" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>None</SelectItem>
          {badges.map((b) => (
            <SelectItem key={b.id} value={b.id}>
              {b.name}
            </SelectItem>
          ))}
          {value && !badges.some((b) => b.id === value) && (
            <SelectItem value={value} disabled>
              Inactive badge
            </SelectItem>
          )}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">
        {disabled && disabledReason
          ? disabledReason
          : "Learners who have already completed this will receive the badge when you save."}
      </p>
    </div>
  );
}
